import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Permission } from "../../../interfaces/permission";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PermissionService } from "../../../services/permission.service";
import { FuenteContratoService } from "../../../services/fuente-contrato.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Response } from "../../../interfaces/response";
import { IFuenteContrato } from 'src/app/interfaces/fuente-contrato';


@Component({
  selector: 'app-fuente-contrato-save',
  templateUrl: './fuente-contrato-save.component.html',
  styleUrls: ['./fuente-contrato-save.component.css']
})
export class FuenteContratoSaveComponent implements OnInit {

  form: FormGroup;
  fuenteContrato: IFuenteContrato;

  @Input() closeMyModal: (any) => void;
  @Input() id_fc: any;
  @Input() tipo: any;
  @Output() salida: EventEmitter<any> = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private fuenteContratoService: FuenteContratoService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id_planta: ['', Validators.required],
      orden_ceco: ['', Validators.required],
      tipo_dv: ['', Validators.required],
      nombre_fc: ['', Validators.required],
      descripcion: ['', Validators.required],
      base_salario: ['', Validators.required],
      v_diur: ['', Validators.required],
      v_noc: ['', Validators.required],
      v_fes_d: ['', Validators.required],
      v_fes_n: ['', Validators.required],
      v_diur_ext: ['', Validators.required],
      v_noc_ext: ['', Validators.required],
      v_fes_d_ext: ['', Validators.required],
      v_fes_n_ext: ['', Validators.required],
      v_f_d_s_c: ['', Validators.required],
      v_f_n_s_c: ['', Validators.required],
      base_salario_cli: ['', Validators.required],
      v_diur_cli: ['', Validators.required],
      v_noc_cli: ['', Validators.required],
      v_fes_d_cli: ['', Validators.required],
      v_fes_n_cli: ['', Validators.required],
      v_diur_ext_cli: ['', Validators.required],
      v_noc_ext_cli: ['', Validators.required],
      v_fes_d_ext_cli: ['', Validators.required],
      v_fes_n_ext_cli: ['', Validators.required],
      v_f_d_s_c_cli: ['', Validators.required],
      v_f_n_s_c_cli: ['', Validators.required],
      v_unidad: ['', Validators.required],
      id_jornales: ['', Validators.required],


    });

    this.fuenteContratoService.get(this.id_fc)
      .subscribe(
        (res: Response) => {
          this.fuenteContrato = res.data;
          this.form.patchValue({
            orden_ceco: this.fuenteContrato.id_fc,
            nombre_ceco: this.fuenteContrato.nombre_fc
          });
        },
        err => console.log('HTTP Error', err)
      );
  }
  submit() {
    const data = this.form.getRawValue();
    if (this.tipo == "edit") {
      // editar el registro
      this.fuenteContratoService.update(this.fuenteContrato.id_fc, data).subscribe(
        (res: Response) => {
          this.salida.emit(res);
        },
      )

    } else {
      // agregar el registro
      this.fuenteContratoService.create(data).subscribe(
        res => {
          this.salida.emit(res);
        }
      );
    }
  }

}
